import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const AboutCustomDesign = () => {
  return (
    <Container className="mt-5">
      <p>
        At Khan Diamonds, we understand that you have unique choices and jewelry
        requirements, and we give you the freedom to choose from many options.
        To fulfill all your needs, we provide state-of-the-art custom jewelry
        designing services. By using the latest technologies along with our
        experienced craftsmen and precise attention to every detail, we take
        pride in mastering the art of jewelry making! Whether you want a
        completely new jewelry piece designed and created, want to customize an
        existing piece, or are looking for the finest custom made jewelry in
        Boston, we’ve got you covered!
      </p>
      <h2 className="text-center font-weight-bold mt-2 mb-4">
        CUSTOM MADE DIAMOND JEWELRY IN BOSTON
      </h2>
      <Row className="align-items-center mb-5">
        <Col md={6}>
          <h4 className="text-uppercase mb-3">Professional Cleaning Inspection</h4>
          <p>
            At Khan Diamonds, we utilize advanced Computer-Aided Design (CAD)
            technology to bring your jewelry visions to life. Our CAD process
            allows us to create detailed 2D drawings and 3D models of your
            custom made diamond jewelry in Boston before it’s manufactured. This
            digital preview ensures that you can visualize the final product
            accurately.
          </p>
          <p>
            If the initial design doesn't meet your expectations, we will revise
            it until you are completely satisfied. Our commitment to perfection
            means you receive only the best final product. Once you approve the
            design, we cast it in the finest quality metal of your choice and
            complete it with expert polishing and rhodium plating.
          </p>
          <p>
            Khan Diamonds transforms your jewelry dreams into reality, providing
            you with pieces that you will cherish for a lifetime. Visit our
            store to discover the finest and unique design of diamond jewelry in
            Boston, MA.
          </p>
          <p>Experience the best in custom jewelry design at Khan Diamonds!</p>
        </Col>
        <Col md={6} className="order-first order-md-last">
          <img className="img-fluid" src={require("../../../Front/themes/showcase/assets/images/custom-design/repair.jpg")} alt="Diamond" />
        </Col>
      </Row>
      <Row className="align-items-center mb-5">
        <Col md={6}>
          <img className="img-fluid" src={require("../../../Front/themes/showcase/assets/images/custom-design/inspection1.jpg")} alt="Diamond" />
        </Col>
        <Col md={6}>
          <h4 className="text-uppercase mb-3">
            CUSTOM DESIGN DIAMOND ENGAGEMENT RINGS BOSTON
          </h4>
          <p>
            Looking to make your special moment even more magical? Khan Diamonds
            has you covered! Visit our store in Boston’s Downtown Crossing to
            explore our exquisite collection of custom design diamond engagement
            rings in Boston , perfect for the special someone in your life. As a
            BBB-accredited business, we focus on every tiny detail to ensure you
            find a gemstone ring that fits your needs and budget.
          </p>
          <p>
            From stunning solitaires to magnificent halos and breathtaking
            three-stone designs, Khan Diamonds offers an abundant array of
            custom made diamond jewelry in Boston to choose from. Our friendly
            in-store sales professionals are here to guide you, helping you
            select the perfect ring according to your preferences. Please note
            that custom-made jewelry, special orders, and sized or altered
            jewelry are final sales.
          </p>
          <p>
            For more details and policies, feel free to call or text us at
            (978)-771-0754. We would love to assist you in finding the perfect
            engagement rings and more unique design diamond jewelry in Boston.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutCustomDesign;
